import { Text } from '@antimatterhq/ui/components/typography';
import { Skeleton } from '@antimatterhq/ui/components/skeleton';

interface HomepageSummaryCardTrendMetricProps {
  label: string;
  value: number | undefined;
  isFetching?: boolean;
}

export const HomepageSummaryCardMainMetric = ({
  label,
  value,
  isFetching,
}: HomepageSummaryCardTrendMetricProps) => (
  <div className="flex flex-col">
    <Text>{label}</Text>
    {isFetching ? (
      <Skeleton className="h-12 w-[50%]" />
    ) : (
      <Text className="heigh" size="3xl" bold>
        {value ?? 0}
      </Text>
    )}
  </div>
);
